import React from 'react';

import { Button, Typography } from '@vtblife/uikit';
import classname from '@search/classname/src';

// import { ClPromoRieltorsTrigger } from '../ClPromoRieltorsTrigger/ClPromoRieltorsTrigger';

import './ClEmptySearch.css';

const cn = classname.bind(null, 'ClEmptySearch');

export const ClEmptySearch: React.FunctionComponent<{
    onResetFilters: () => void;
    openSaveSearch: () => void;
    renderIcon?: React.ReactNode;
    isMobile?: boolean;
    regionId: number;
    showPromoRieltors?: boolean;
}> = ({
    onResetFilters,
    // openSaveSearch,
    renderIcon,
    isMobile,
    // regionId,
    // showPromoRieltors
}) => {
    return (
        <div className={cn('', { isMobile })}>
            {renderIcon ? <div className={cn('icon')}>{renderIcon}</div> : null}
            <div>
                <Typography variant={isMobile ? 'h4' : 'h3'} bold>
                    По&nbsp;вашему запросу не&nbsp;нашлось предложений
                </Typography>
                <Typography variant='primary' className={cn('main-text')}>
                    {/* eslint-disable-next-line max-len */}
                    Попробуйте сбросить фильтры или сохраните это поиск и&nbsp;получайте уведомления о&nbsp;новых объявлениях на&nbsp;почту.
                </Typography>
                <div className={cn('buttons', { isMobile })}>
                    {/*<Button onClick={openSaveSearch} size={isMobile ? 's' : 'm'}>*/}
                    {/*    Сохранить поиск*/}
                    {/*</Button>*/}
                    <Button
                        variant='secondary'
                        onClick={onResetFilters}
                        size={isMobile ? 's' : 'm'}
                    >
                        Сбросить фильтры
                    </Button>
                </div>
                {/* eslint-disable-next-line max-len */}
                {/*{showPromoRieltors ? <ClPromoRieltorsTrigger regionId={regionId} isMobile={isMobile} view='serp' /> : null}*/}
            </div>
        </div>
    );
};

